<template>
  <b-row class="d-flex align-items-center m-0">
    <b-col
      cols="12"
      lg="12"
      md="6"
      sm="6"
      class="area3 p-0"
    >
      <div
        v-if="configData.area3.buttons.length > 0"
        class="area-3"
        :style="area3Style"
      >
        <template-button
          v-for="btn, index in configData.area3.buttons"
          :key="index"
          :btn-config="btn"
        />
      </div>
      <template-empty-area
        v-else
        :area-name="'板塊(三)'"
        :default-height="'300px'"
      />
    </b-col>

    <b-col
      cols="12"
      lg="12"
      md="6"
      sm="6"
      class="area4 p-0"
    >
      <div
        v-if="configData.area4.buttons.length > 0"
        class="area-4"
        :style="area4Style"
      >
        <template-button
          v-for="btn, index in configData.area4.buttons"
          :key="index"
          :btn-config="btn"
        />
      </div>
      <template-empty-area
        v-else
        :area-name="'板塊(四)'"
        :default-height="'300px'"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import TemplateButton from '../component/TemplateButton.vue'
// import TemplateButtonList from '../component/TemplateButtonList.vue'
import TemplateEmptyArea from '../component/TemplateEmptyArea.vue'

export default {
  components: {
    BRow,
    BCol,
    TemplateButton,
    TemplateEmptyArea,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      area3Style: null,
      area4Style: null,
    }
  },
  mounted() {
    this.area3Style = this.configData.area3.config
    this.area4Style = this.configData.area4.config
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.area-3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: var(--padding);
  margin: var(--margin);
  @media screen and (max-width: 575px) {
    flex-wrap: wrap;
    flex-direction: row;
    margin-bottom: 1rem;
  }
}
.area-4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: var(--padding);
  margin: var(--margin);
  @media screen and (max-width: 575px) {
    flex-wrap: wrap;
    flex-direction: row;
    margin-bottom: 1rem;
  }
}
</style>
